export default __webpack_public_path__ + "static/media/ico_mail.e9c73a0c.svg";